import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImprimirComponent } from './imprimir.component';
import { ButtonModule } from 'primeng/button';



@NgModule({
    declarations: [ImprimirComponent],
    imports: [ 
        CommonModule,
        ButtonModule 
    ],
    exports: [ ImprimirComponent ],
    providers: [],
})
export class ImprimirSharedModule {}